import {v4 as uuid} from "../../__snowpack__/pkg/uuid.js";
export const useGlobalChannel = () => {
  let channel = null;
  const createBc = (channelName) => {
    try {
      if (typeof BroadcastChannel !== "undefined") {
        channel = new BroadcastChannel(channelName ? channelName : uuid());
        return channel;
      } else {
        console.log("\u5F53\u524D\u6D4F\u89C8\u5668\u4E0D\u652F\u6301 BroadcastChannel");
        return false;
      }
    } catch (error) {
      console.error(error);
    }
  };
  const closeBc = () => {
    try {
      if (typeof BroadcastChannel !== "undefined" && channel) {
        channel.close();
      } else {
        console.log("\u5F53\u524D\u6D4F\u89C8\u5668\u4E0D\u652F\u6301 BroadcastChannel");
      }
    } catch (error) {
      console.error(error);
    }
  };
  return {
    createBc,
    closeBc
  };
};
